import { AbstractResource } from '../abstract';

export class AbstractVerificationResource extends AbstractResource {
    private _apiFramework: string | null;
    constructor() {
        super();
        this._apiFramework = null;
    }

    get apiFramework() {
        return this._apiFramework;
    }

    set apiFramework(value) {
        this._apiFramework = value;
    }
}
